// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbItem":"Breadcrumb_breadcrumbItem__x_rag","isBlue":"Breadcrumb_isBlue__m0LLh"};